import * as legacyEvent from './Event';
import * as resource from './Resource';
import * as types from './Types';
import * as trace from './Trace';
import * as serviceApi from './ServiceAPI';

import ServiceAPIFB = serviceApi.com.tableausoftware.endeavour.protocol.v1.api;
import LegacyEventFB = legacyEvent.com.tableausoftware.telemetry.protocol;
import ResourceFB = resource.com.tableausoftware.endeavour.protocol.v1.resource.Resource;
import TypesFB = types.com.tableausoftware.endeavour.protocol.v1.types;
import TraceFB = trace.com.tableausoftware.endeavour.protocol.v1.trace;

export { ServiceAPIFB, LegacyEventFB, ResourceFB, TypesFB, TraceFB };
